import React from "react";
import { Link } from "react-router-dom";

import Navigator from "../Elements/Navigator";
import MenuFunctionIcons from "../Elements/MenuFunctionIcons";
import { renderContainer } from "../../../common/utils";
import logo from "../../../assets/images/logo/logolariales.png";

export default function MenuThree({ hide, container }) {
  return (
    <div className="menu -style-3">
      <div className={renderContainer(container)}>
        <div className="menu__wrapper">
          <Link to="/">
            <a className="menu__wrapper__logo">
              <img
                src={logo}
                alt="Logo"
              />
            </a>
          </Link>
          <Navigator className="-white" />
          <MenuFunctionIcons hide={hide} white className="-white" />
        </div>
      </div>
    </div>
  );
}
